import { render, staticRenderFns } from "./BankTransferPage.vue?vue&type=template&id=6cb43a3c&scoped=true"
import script from "./BankTransferPage.vue?vue&type=script&lang=js"
export * from "./BankTransferPage.vue?vue&type=script&lang=js"
import style0 from "./BankTransferPage.vue?vue&type=style&index=0&id=6cb43a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb43a3c",
  null
  
)

export default component.exports